module.exports = __webpack_public_path__ + "img/712.a2e2881f.jpg";